'use strict';

const motionComponentSymbol = Symbol.for("motionComponentSymbol");

exports.motionComponentSymbol = motionComponentSymbol;
//# sourceMappingURL=symbol.cjs.map
